import script from "./AppointmentView.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppointmentView.vue?vue&type=script&lang=ts&setup=true"

import "./AppointmentView.vue?vue&type=style&index=0&id=21e237ab&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/jobs/MASSMEDIAN_MYPAGE_VIEW_PROD/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21e237ab"]])

export default __exports__